export const BINDING_QUOTE_DEBOUNCE_MS = 500;

export function isBindingQuoteReady(params: {
  capabilityKey: string | null | undefined;
  fundingMethod: string | null | undefined;
  payoutMethod: string | null | undefined;
  amount: number | null | undefined;
}): boolean {
  return Boolean(
    params.capabilityKey &&
      params.fundingMethod &&
      params.payoutMethod &&
      params.amount &&
      params.amount > 0
  );
}

/**
 * UI after the quote request identity changes, before the debounced fetch.
 * Incomplete compose must not look like a loading confirm (nudge stays clickable).
 */
export function quoteUiOnIdentityChange(ready: boolean): {
  loading: boolean;
  clearQuote: boolean;
} {
  if (!ready) return { loading: false, clearQuote: true };
  return { loading: true, clearQuote: true };
}

export function quoteMatchesSelection(
  quote: {
    fundingMethod: string;
    payoutMethod?: string;
    capabilityKey?: string;
  } | null,
  quoteLoading: boolean,
  selection: {
    fundingMethod?: string | null;
    payoutMethod?: string | null;
    capabilityKey?: string | null;
  }
): boolean {
  if (!quote || quoteLoading) return false;
  if (
    selection.fundingMethod == null &&
    selection.payoutMethod == null
  ) {
    return false;
  }
  if (
    selection.fundingMethod != null &&
    quote.fundingMethod !== selection.fundingMethod
  ) {
    return false;
  }
  if (
    selection.payoutMethod != null &&
    quote.payoutMethod !== selection.payoutMethod
  ) {
    return false;
  }
  if (quote.capabilityKey && quote.capabilityKey !== selection.capabilityKey) {
    return false;
  }
  return true;
}
